// Consultauto — First-party traffic tracker (anonymous, no PII)
const API = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = 'ca_traffic_sid';

function getSid() {
  try {
    let sid = sessionStorage.getItem(SID_KEY);
    if (!sid) {
      sid = 't_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SID_KEY, sid);
    }
    return sid;
  } catch {
    return 't_fallback';
  }
}

function getUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    return {
      utm_source: p.get('utm_source') || '',
      utm_medium: p.get('utm_medium') || '',
      utm_campaign: p.get('utm_campaign') || '',
      utm_content: p.get('utm_content') || '',
      utm_term: p.get('utm_term') || '',
      ref: p.get('ref') || '',
    };
  } catch {
    return {};
  }
}

function send(payload) {
  try {
    const body = JSON.stringify(payload);
    const url = `${API}/api/traffic/ping`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch {}
}

export function trackView(path) {
  if (path.startsWith('/admin')) return;
  send({
    sessionId: getSid(),
    type: 'view',
    path,
    referrer: document.referrer || '',
    ...getUtm(),
    device: window.innerWidth < 768 ? 'mobile' : 'desktop',
  });
}

export function trackCtaClick(label, path) {
  send({ sessionId: getSid(), type: 'click', path: path || window.location.pathname, label });
}

let beatTimer = null;
export function startHeartbeat() {
  if (beatTimer) return;
  beatTimer = setInterval(() => {
    const path = window.location.pathname;
    if (document.visibilityState === 'visible' && !path.startsWith('/admin')) {
      send({ sessionId: getSid(), type: 'beat', path });
    }
  }, 20000);
}

let clicksInit = false;
export function initClickTracking() {
  if (clicksInit) return;
  clicksInit = true;
  document.addEventListener('click', (e) => {
    try {
      const el = e.target.closest && e.target.closest('a, button');
      if (!el) return;
      const path = window.location.pathname;
      if (path.startsWith('/admin')) return;
      const href = el.getAttribute('href') || '';
      const text = (el.textContent || '').trim().slice(0, 60);
      if (href.startsWith('tel:')) {
        trackCtaClick('appel-telephone', path);
      } else if (href.startsWith('mailto:')) {
        trackCtaClick('clic-courriel', path);
      } else if (href.includes('/rendez-vous') || /planifier|consultation|session strat/i.test(text)) {
        trackCtaClick(`cta-rdv · ${text || href}`.slice(0, 110), path);
      }
    } catch {}
  }, true);
}
